import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10b1b020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "udc-camera-select" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = ["onClick"]

import { ref, computed, watch, PropType } from 'vue'
import { find } from 'lodash'

type Option = {
  label: string
  value: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  options: {
    type: Array as PropType<Option[]>,
    default: () => [],
  },
  modelValue: {
    type: String,
  },
  defaultLabel: {
    type: String,
    optional: true,
    default: '時間切替',
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit }) {

const props = __props





const open = ref<boolean>(false)
const selected = ref<string | undefined>(props.modelValue)
const firstClick = ref<boolean>(true)

const selectedLabel = computed(() => {
  if (props.options.length === 0) {
    return ''
  }

  if (props.modelValue) {
    const row = props.options.find(o => o.value === props.modelValue)

    return row?.label
  }

  return find(props.options, { value: selected.value })?.label
})

const select = (value: string) => {
  open.value = false
  selected.value = value
}

const handleClickSelect = () => {
  open.value = !open.value
  firstClick.value = false
}

watch(
  () => selected.value,
  () => {
    emit('update:modelValue', selected.value)
    emit('change', selected.value)
  }
)

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue) {
      selected.value = props.modelValue
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: handleClickSelect,
      class: "selected"
    }, _toDisplayString(_unref(selectedLabel)), 1),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (select(option.value)),
          class: "option",
          key: index
        }, _toDisplayString(option.label), 9, _hoisted_3))
      }), 128))
    ], 512), [
      [_vShow, open.value]
    ])
  ]))
}
}

})